import { render, staticRenderFns } from "./AddMyAccount.vue?vue&type=template&id=ec93b63a"
import script from "./AddMyAccount.vue?vue&type=script&lang=ts"
export * from "./AddMyAccount.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports